import { getLocaleFromNavigator } from 'svelte-i18n';
import { alpha2ToAlpha3 } from 'i18n-iso-countries';
/* ENVIRONMENT: development / staging / production */
const getEnvironment = () => {
    if (window.location.hostname.endsWith('smatch.com')) {
        return 'production';
    }
    if (window.location.hostname.endsWith('smatch.dev')) {
        return 'staging';
    }
    return 'development';
};
export const ENVIRONMENT = getEnvironment();
/* DEVICE : desktop / phone / tablet */
const getPlatform = () => {
    if (typeof window.navigator === 'undefined') {
        return 'app';
    }
    return 'web';
};
const MAX_TABLET_DIMENSIONS_RATIO = 1.75;
const getWebDevice = () => {
    const DIMENSIONS = [window.innerWidth, window.innerHeight];
    const RATIO = Math.max.apply(null, DIMENSIONS) / Math.min.apply(null, DIMENSIONS);
    if (typeof screen.orientation !== 'undefined') {
        return 'desktop';
    }
    if (RATIO <= MAX_TABLET_DIMENSIONS_RATIO) {
        return 'tablet';
    }
    return 'phone';
};
const getAppDevice = () => 'phone';
const getDevice = () => {
    if (getPlatform() === 'web') {
        return getWebDevice();
    }
    return getAppDevice();
};
export const DEVICE = getDevice();
/* LOCALE: COUNTRY CODE & LANGUAGE CODE */
const LOCALE = getLocaleFromNavigator();
const [, COUNTRY] = LOCALE?.split('-') ?? [];
export const COUNTRY_CODE = alpha2ToAlpha3(Boolean(COUNTRY) ? COUNTRY : 'DE') ?? 'DEU';
export const LANGUAGE_CODE = LOCALE ?? 'en-GB';
